import styled from 'styled-components';

export const AddShippingContainer = styled.div`
  text-align: center;
`;

export const NewShippingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AddShippingInput = styled.input`
  margin: 8px;
  padding: 2px;
  width: 300px;
`;

export const AddShippingButton = styled.button`
  font-family: 'Open Sans Condensed';
  font-weight: bolder;
  text-transform: uppercase;
  color: #fff;
  background-color: #000;
  border: none;
  border-radius: 2px;
  margin: 10px 1px 0 1px;
  height: 50px;
  width: 150px;

  &:hover {
    color: #000;
    background-color: #fff;
    border: #000 solid 1px;
  }
`;